mutation SendTestEventEmail($eventId: ID!, $emailKind: String!) {
  sendTestEventEmail(input: { eventId: $eventId, emailKind: $emailKind }) {
    deliveredTo
  }
}
